export const servicePricingTypeEnum = {
  PER_PERSON: 1,
  PER_UNIT: 2,
  PER_CONSUMPTION: 3
}
